export const propertyRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  paddingTop: '6px',
  paddingLeft: '12px',
  borderLeft: ({ palette }) => `2px solid ${palette.divider}`,
};

export const arrowStyles = {
  color: 'text.secondary',
  padding: '0 4px',
};

export const valueRowStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  gap: '4px',
};
